// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__agoMf","question":"styles_question__3IIn3","inputVisibleButton":"styles_inputVisibleButton__3UCua","note":"styles_note__348tE"};